import { UserFeatureFlagType } from '../../../context/UserFeatureFlagContext';
import { UserEntity } from '@backstage/catalog-model';
import { usePlatformFeatureFlagContext } from '../../../context';
import List from '@mui/material/List';

import { UserFeatureFlagItem } from './UserFeatureFlagItem';

type Props = {
  userFeatures: UserFeatureFlagType;
  user?: UserEntity;
};

export const UserFeatureFlags = ({ userFeatures, user }: Props) => {
  const { findPlatformFeatureFlag } = usePlatformFeatureFlagContext();

  return (
    <List dense>
      {Object.keys(userFeatures).map(feature => {
        return (
          !findPlatformFeatureFlag(feature)?.selectable && (
            <UserFeatureFlagItem feature={feature} user={user} key={feature} />
          )
        );
      })}
    </List>
  );
};
